/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.27
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CostLaborFromJSON(json) {
    return CostLaborFromJSONTyped(json, false);
}
export function CostLaborFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'costId': !exists(json, 'costId') ? undefined : json['costId'],
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'laborName': !exists(json, 'laborName') ? undefined : json['laborName'],
        'laborWorkerId': !exists(json, 'laborWorkerId') ? undefined : json['laborWorkerId'],
        'laborRate': !exists(json, 'laborRate') ? undefined : json['laborRate'],
        'laborDate': !exists(json, 'laborDate') ? undefined : (json['laborDate'] === null ? null : new Date(json['laborDate'])),
        'laborHours': !exists(json, 'laborHours') ? undefined : json['laborHours'],
        'laborHoursOverTime': !exists(json, 'laborHoursOverTime') ? undefined : json['laborHoursOverTime'],
        'workorderType': !exists(json, 'workorderType') ? undefined : json['workorderType'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'tcardRecordType': !exists(json, 'tcardRecordType') ? undefined : json['tcardRecordType'],
        'tcardNotes': !exists(json, 'tcardNotes') ? undefined : json['tcardNotes'],
        'orderNumber': !exists(json, 'orderNumber') ? undefined : json['orderNumber'],
    };
}
export function CostLaborToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'costId': value.costId,
        'workorderId': value.workorderId,
        'propertyId': value.propertyId,
        'laborName': value.laborName,
        'laborWorkerId': value.laborWorkerId,
        'laborRate': value.laborRate,
        'laborDate': value.laborDate === undefined ? undefined : (value.laborDate === null ? null : value.laborDate.toISOString()),
        'laborHours': value.laborHours,
        'laborHoursOverTime': value.laborHoursOverTime,
        'workorderType': value.workorderType,
        'notes': value.notes,
        'tcardRecordType': value.tcardRecordType,
        'tcardNotes': value.tcardNotes,
        'orderNumber': value.orderNumber,
    };
}
